import { useQuery } from "@tanstack/react-query"

import { useAuth } from "src/context/AuthContext"

/**
 * Fetches the intro message for a public channel from GET /intro_message/<channelId>.
 * Returns audio_url, speech_marks, avatar_id, and psk_name.
 *
 * staleTime is set to Infinity — the intro message for a channel does not change
 * frequently, and we only want to play it once per session (callers gate playback
 * separately via MMKV).
 */
export function useUnauthIntroMessage(channelId: string | null) {
  const { authApi } = useAuth()

  return useQuery({
    queryKey: ["unauth", "intro_message", channelId],
    queryFn: async () => {
      const response = await authApi.getIntroMessage(channelId!)
      if (response.kind === "not-found") {
        return null
      }
      if (response.kind !== "ok") {
        throw new Error(`Failed to fetch intro message: ${response.kind}`)
      }
      return response.data
    },
    enabled: !!channelId,
    staleTime: Infinity,
    retry: false,
  })
}
